import axios from "axios";

const externalApi = axios.create({
  baseURL: "https://nominatim.openstreetmap.org",
  timeout: 10000,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

export const getReverseGeocoding = async (latitude, longitude) => {
  try {
    const response = await externalApi.get('/reverse', {
      params: {
        lat: latitude,
        lon: longitude,
        format: 'json',
        zoom: 18,
        addressdetails: 1
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar geolocalização:', error);
    throw new Error('Não foi possível obter a localização');
  }
};